import styles from './FJFaceSwapLeftRight.module.less';
import FJDisplayHeaderContainer from '../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJCreationPanelContainer from '../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer';
import FJHistoryPanelContainer from '../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const FJFaceSwapLeftRight = ({ isEmptyCreationList, headerTabIndex }) => {
    return (
        <div
            className={classNames(
                styles.app_right,
                isEmptyCreationList && headerTabIndex === 0 && styles.empty_creation_list,
            )}
        >
            <FJDisplayHeaderContainer isShowProgress={false} isHideBottomLine={isEmptyCreationList} />

            <FJCreationPanelContainer activeHeaderTabIndex={0} />

            <FJHistoryPanelContainer activeHeaderTabIndex={1} />
        </div>
    );
};

FJFaceSwapLeftRight.propTypes = {
    isEmptyCreationList: PropTypes.bool,
    headerTabIndex: PropTypes.number,
};

export default FJFaceSwapLeftRight;
